import { Container, Box, Typography } from '@mui/material';

function AlannahJoke() {
    return (
        <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', pt: { xs: 4, sm: 8 } }}>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    mb: { xs: 4, sm: 6 },
                }}
            >
                <Typography
                    variant="h2"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 900,
                        letterSpacing: 2,
                        textAlign: 'center',
                        fontSize: { xs: '2.2rem', sm: '3.5rem', md: '4rem' },
                        background: 'linear-gradient(90deg, #ff8a00 0%, #e52e71 25%, #42e695 50%, #3a8dde 75%, #ff8a00 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        textShadow: '0 2px 8px rgba(229,46,113,0.15), 0 4px 24px rgba(66,230,149,0.10)',
                        borderRadius: 2,
                        px: { xs: 1, sm: 2 },
                        py: { xs: 0.5, sm: 1 },
                        fontFamily: 'Montserrat, Comic Sans MS, cursive, sans-serif',
                        userSelect: 'none',
                        boxShadow: '0 2px 12px 0 rgba(255,138,0,0.10)',
                        animation: 'bounce 1.5s infinite',
                        '@keyframes bounce': {
                            '0%, 100%': { transform: 'translateY(0)' },
                            '50%': { transform: 'translateY(-12px)' },
                        },
                    }}
                >
                    🎉 Happy Birthday Alannah! 🎂
                </Typography>
                <Typography
                    variant="subtitle1"
                    component="h2"
                    sx={{
                        mt: { xs: 1, sm: 2 },
                        fontSize: { xs: '1.1rem', sm: '1.5rem', md: '1.7rem' },
                        textAlign: 'center',
                        color: 'text.secondary',
                        fontFamily: 'Montserrat, Comic Sans MS, cursive, sans-serif',
                        fontWeight: 400,
                        letterSpacing: 1,
                        userSelect: 'none',
                        textShadow: '0 1px 4px rgba(58,141,222,0.10)',
                    }}
                >
                    who knew you were right all this time...
                </Typography>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mt: { xs: 3, sm: 4 },
                    }}
                >
                    <img
                        src={process.env.PUBLIC_URL + '/bird_hater.jpeg'}
                        alt="A funny bird hater birthday joke"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            borderRadius: '16px',
                            boxShadow: '0 4px 24px rgba(58,141,222,0.10)',
                        }}
                    />
                </Box>
            </Box>
        </Container>
    );
}

export default AlannahJoke